import { inactivityTimeOut } from "domain/utils/inactivityTimeout";
import { createStore } from "zustand";
import { devtools } from "zustand/middleware";

export interface IAuthState {
    isLoggedIn: boolean;
    inactivityTimeOut: ((fn: () => void, timeoutValue?: number) => void) | null;
}

export const defaultUserState: IAuthState = {
    isLoggedIn: false,
    inactivityTimeOut,
};

const authState = createStore<IAuthState>()(devtools(() => defaultUserState, { name: "authState" }));

export default authState;
